let listeners = new Set();
let activeAlert = null;

export const API_ALERT_VARIANT = {
  SESSION_EXPIRED: "sessionExpired",
  ERROR: "error",
};

export const isApiAlertActive = () => activeAlert != null;

export const subscribeApiAlert = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const publishAlert = (alert) => {
  if (activeAlert) return;
  activeAlert = alert;
  listeners.forEach((listener) => listener(activeAlert));
};

export const showSessionExpiredAlert = () => {
  publishAlert({
    variant: API_ALERT_VARIANT.SESSION_EXPIRED,
    message: "Session Expired. Please Login again",
  });
};

export const showApiErrorAlert = (message) => {
  const text = typeof message === "string" ? message.trim() : "";
  if (!text) return;
  publishAlert({
    variant: API_ALERT_VARIANT.ERROR,
    message: text,
  });
};

export const resetApiAlertState = () => {
  activeAlert = null;
};

export const clearClientSession = () => {
  try {
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("status");
    localStorage.removeItem("persist:root");
  } catch {
    // ignore
  }
};

export const isTokenInvalidText = (value) => {
  const msg = typeof value === "string" ? value.trim().toLowerCase() : "";
  if (!msg) return false;
  return (
    msg.includes("token is invalid") ||
    msg.includes("token invalid") ||
    msg.includes("invalid token") ||
    msg.includes("jwt expired") ||
    msg.includes("session expired") ||
    msg.includes("session has expired")
  );
};

export const readApiMessageFromBody = (body) => {
  if (!body || typeof body !== "object") return "";
  const msg = body.errorMessage ?? body.message ?? body.msg;
  return typeof msg === "string" ? msg.trim() : "";
};

/** Business/API errors stay in-app with toast; only real auth failures log the user out. */
export const shouldTreatHttpFailureAsSessionExpired = (httpStatus, body) => {
  if (![401, 403].includes(httpStatus)) return false;

  const msg = readApiMessageFromBody(body);
  if (isTokenInvalidText(msg)) return true;

  const c = body?.code;
  const codeNum = typeof c === "string" ? parseInt(c, 10) : c;

  if (typeof codeNum === "number" && !Number.isNaN(codeNum) && codeNum !== 200 && codeNum !== 201) {
    if (msg) return false;
    if (codeNum === 401 && httpStatus === 401) return true;
    return false;
  }

  if (msg) return false;

  return httpStatus === 401;
};
